/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface About { 
    readonly version?: string;
    /**
     * timestamp when the application was last started
     */
    readonly startTime?: Date;
    /**
     * uptime in milliseconds for the running application
     */
    readonly uptime?: number;
    /**
     * status of the backend
     */
    status?: About.StatusEnum;
    /**
     * root url for robot-config
     */
    baseUrl?: string;
}
export namespace About {
    export type StatusEnum = 'RUNNING' | 'STARTING' | 'STOPPING';
    export const StatusEnum = {
        RUNNING: 'RUNNING' as StatusEnum,
        STARTING: 'STARTING' as StatusEnum,
        STOPPING: 'STOPPING' as StatusEnum
    };
}


